import { Box, Typography, Link, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import LegalPage from '../../components/common/LegalPage';

// Structure mirrors references/ProdWebsite/frontend/src/pages/business/businessProfiles.js
const branches = [
  {
    name: 'Cherry Creek Mortgage, LLC — Corporate Office',
    address: '5600 S Quebec St, Ste 100-D, Greenwood Village, CO 80111',
    phone: '800-295-4439',
  },
  {
    name: 'Cherry Creek Mortgage, LLC — Branch Office',
    address: '9805 Double R Blvd, Ste 300, Office 3025, Reno, NV 89521',
    phone: '833-270-7191x1048',
  },
];

const mapsUrl = (address) =>
  `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(address)}`;

export default function BusinessProfiles() {
  return (
    <LegalPage title="Cherry Creek Mortgage, LLC — Branch Addresses">
      <Box>
        <TableContainer component={Paper} elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
          <Table aria-label="branch addresses">
            <TableHead>
              <TableRow>
                <TableCell sx={{ fontWeight: 700 }}>Branch Name</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Property Address</TableCell>
                <TableCell sx={{ fontWeight: 700 }}>Phone</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {branches.map((b) => (
                <TableRow key={b.name} hover>
                  <TableCell>{b.name}</TableCell>
                  <TableCell>
                    <Link href={mapsUrl(b.address)} target="_blank" rel="noopener noreferrer" underline="hover">
                      {b.address}
                    </Link>
                  </TableCell>
                  <TableCell>
                    <Link href={`tel:${b.phone.replace(/[^\d]/g, '')}`} underline="hover">
                      {b.phone}
                    </Link>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <Typography variant="caption" sx={{ display: 'block', mt: 2 }} color="text.secondary">
          Click an address to open in Google Maps, or tap a phone number to call.
        </Typography>
      </Box>
    </LegalPage>
  );
}
